import {ShippingForm} from "./ShippingForm";
import {useEffect, useState} from "react";
import * as Constants from "../../constants/urls";
import axios from "axios";
import {useCookies} from "react-cookie";
import {PacksModal} from "../Modal/PacksModal";
import {useParams} from "react-router-dom";

export const EditShipping = () => {
    const [response, setResponse] = useState(null);
    const [status, setStatus] = useState(true);
    const [packId, setPackId] = useState(undefined);
    const [packs, setPacks] = useState(undefined);
    const [modal, setModal] = useState(undefined);
    const [data, setData] = useState(undefined);
    const [cookies, setCookie, removeCookie] = useCookies();
    const id = useParams().id;

    const changePackId = (e) => {
        setPackId(e.target.value);
    }
    const changeStatus = (e) => {
        setStatus(e.target.checked);
    }
    const openModal = () => {
        setModal(true);
    }
    useEffect(() => {
        getPacks();
        getData();
    }, []);
    const getData = () => {
        const url = Constants.apiUrl + "/api/shipping/show/" + id;
        axios.get(url, {
            headers: {
                Authorization: "Bearer " + cookies.user_server_token,
            },
        })
            .then((r) => {
                setPackId(r.data.pack_id);
                setStatus(r.data.status);
            })
            .catch((e) => {

            });
    }
    const searchPack = (query) => {
        if (query == "")
            getPacks();
        else
            searchPackApi(query);
    }
    const searchPackApi = (query) => {
        const url = Constants.apiUrl + "/api/packs/search" ;
        axios.post(url, {
            text: query,
        }, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setPacks(r.data)
        }).catch((e) => {
        });
    }
    const getPacks = (n = 1) => {
        const url = Constants.apiUrl + "/api/packs/paginate?page=" + n;
        axios.get(url, {
            headers: {
                Authorization: "Bearer " + cookies.user_server_token,
            },
        })
            .then((r) => {
                setPacks(r.data);
            })
            .catch((e) => {

            });
    }
    const update = () => {
        const url = Constants.apiUrl + "/api/shipping/update";
        axios.post(url, {
            status: status,
            pack_id: packId,
            id: id
        }, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setResponse(true);
        }).catch((e) => {
            setResponse(false);
        });
    }
    return (
        <>
            {response == true && <div className={"alert alert-success text-center"}>عملبات با موفقیت انجام شد</div>}
            {response == false && <div className={"alert alert-danger text-center"}>عملبات با شکست روبرو شد</div>}
            <ShippingForm
                type={"update"}
                action={update}
                status={status}
                packId={packId}
                modal={openModal}
                changeStatus={changeStatus}/>
            {modal &&
                <PacksModal
                get={(n) => { getPacks(n) }}
                packs={packs}
                close={()=>{setModal(false);} }
                select={(e) => { setPackId(e);setModal(false)}}
                search={(e)=>searchPack(e)}
            />}
        </>
    )
}
